"use client";

import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/api/api";
import { useLanguage } from "@/context/LanguageContext";

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
   const { language } = useLanguage(); // if you already store language
  const [domain, setDomain] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDomain = async () => {
      try {
        const res = await api.get("/domains/current", {
          params: { lang: language || "en" },
        });

        if (res.data?.success) {
          setDomain(res.data.data);
        } else {
          setError("Domain data not available");
        }
      } catch (err) {
        console.error("Domain API error:", err);
        setError("Failed to load domain data");
      } finally {
        setLoading(false);
      }
    };

    fetchDomain();
  }, [language]);

  return (
    <DomainContext.Provider value={{ domain, loading, error }}>
      {children}
    </DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);
